export default __webpack_public_path__ + "static/media/sit-stamp.8f0293e9.png";